import { gql } from '@apollo/client';
import { SourceFragment, ActivityFragment } from './fragments';

export default gql`
  ${SourceFragment}
  ${ActivityFragment}
  query Client($shortName: String!) {
    clientCollection(where: { shortName: $shortName }, limit: 1) {
      items {
        sys {
          id
        }
        name
        slug
        url
        shortName
        logoReverse {
          url
        }
        sponsor
        primaryColor
        userRatingCutoff
        expertRatingCutoff
        averageRatingCutoff
        facebook
        instagram
        twitter
        allowSignIn
        msOAuthSignIn
        googleSignIn
        facebookSignIn
        cmSignIn
        metadata
        crediblemindLogo {
          url
        }
        excludeTopicCollection {
          items {
            title
            slug
            reviewStatus
            type
            description
            sys {
              id
            }
            image {
              url
            }
          }
        }
        landingLinksCollection {
          items {
            title
            slug
            menuTitle
            menuImage {
              url
            }
            showMenu
            menuOrder
          }
        }
        partnerCollection {
          items {
            slug
            url
            name
            logoReverse {
              url
            }
          }
        }
        clientResourcesCollection {
          items {
            ...ClientSourceFields
            ...ClientActivityFields
          }
        }
        inCrisisIntro {
          json
        }
        signUpIntro {
          json
        }
        inCrisisResourcesCollection {
          items {
            ...ClientSourceFields
            ...ClientActivityFields
          }
        }
        topicPanel
        context
      }
    }
  }
`;
